"use client";

import { useState } from "react";
import Image from "next/image";
import { isOptimizableImageHost } from "@/lib/events";

interface Props {
  src: string;
  alt: string;
}

// El recorte de imagen de evento tiene aspecto libre (horizontal o vertical
// según lo que suba cada organizador), así que todas las imágenes —propias o
// scrapeadas— usan el mismo tratamiento: fondo difuminado detrás + la imagen
// completa (object-scale-down) al frente, sin recortar lo que el usuario
// encuadró.
export function EventCoverImage({ src, alt }: Props) {
  const [imgSrc, setImgSrc] = useState(src);
  const unoptimized = !isOptimizableImageHost(imgSrc);

  return (
    <>
      <Image
        src={imgSrc}
        alt=""
        aria-hidden
        fill
        unoptimized={unoptimized}
        onError={() => setImgSrc("/images/event-music.jpg")}
        className="scale-110 object-cover blur-2xl brightness-75"
        sizes="(max-width: 1280px) 100vw, 1280px"
      />
      <Image
        src={imgSrc}
        alt={alt}
        fill
        priority
        unoptimized={unoptimized}
        onError={() => setImgSrc("/images/event-music.jpg")}
        className="object-scale-down"
        sizes="(max-width: 1280px) 100vw, 1280px"
      />
    </>
  );
}
